import {Component, forwardRef, Injector} from "@angular/core";
import {AbstractEditControlComponent} from "../../../entity/edit/edit-controls/abstract-edit-control.component";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DateEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-date-edit-control",
    templateUrl: "./date-edit-control.component.html",
    providers: [CUSTOM_VALUE_ACCESSOR]
})
export class DateEditControlComponent extends AbstractEditControlComponent {

    constructor(injector: Injector) {
        super(injector);
    }
}
